import React from 'react';

// The model's replies use a little Markdown: paragraphs, - or 1. lists, **bold** and `code`.
// This renders just that, as React elements (never as HTML).

const inline = (line) => line.split(/(\*\*[^*]+\*\*|`[^`]+`)/g).map((part, i) => {
  if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
    return <strong key={i} className="font-bold text-ink">{part.slice(2, -2)}</strong>;
  }
  if (part.startsWith('`') && part.endsWith('`') && part.length > 2) {
    return <code key={i} className="font-mono text-data-sm text-ink">{part.slice(1, -1)}</code>;
  }
  return part;
});

const BULLET = /^\s*[-*•]\s+/;
const NUMBERED = /^\s*\d+[.)]\s+/;

export const ChatText = ({ text = '' }) => {
  const blocks = text.replace(/\r/g, '').split(/\n{2,}/).map((block) => block.trim()).filter(Boolean);
  return (
    <div className="flex flex-col gap-space-3 font-text text-body text-ink-soft">
      {blocks.map((block, b) => {
        const lines = block.split('\n');
        const isList = lines.every((line) => BULLET.test(line) || NUMBERED.test(line));
        if (isList) {
          const ordered = NUMBERED.test(lines[0]);
          const List = ordered ? 'ol' : 'ul';
          return (
            <List key={b} className={`m-0 pl-space-6 flex flex-col gap-space-1 ${ordered ? 'list-decimal' : 'list-disc'}`}>
              {lines.map((line, i) => <li key={i}>{inline(line.replace(ordered ? NUMBERED : BULLET, ''))}</li>)}
            </List>
          );
        }
        // Headings become bold lines
        const heading = block.match(/^#{1,6}\s+(.*)$/);
        if (heading && lines.length === 1) {
          return <p key={b} className="m-0 font-bold text-ink">{inline(heading[1])}</p>;
        }
        return (
          <p key={b} className="m-0">
            {lines.map((line, i) => <React.Fragment key={i}>{i > 0 && <br />}{inline(line)}</React.Fragment>)}
          </p>
        );
      })}
    </div>
  );
};
